<template>
  <div class="block_wrap">
    <div class="line">
      <label> {{ translate('device.group.many') }} </label>
      <sis-select
        :options="group_list"
        :flat="true"
        v-model="user_group"
        :placeholder="translate('device.group.many')"
        :multiple="true"
      />
    </div>

<!--    <div class="line">-->
<!--      <label> {{ translate('device.group.many') }} </label>-->
<!--      <sis-select-->
<!--          :options="group_list"-->
<!--          :flat="true"-->
<!--          v-model="user_group"-->
<!--          :placeholder="translate('device.group.many')"-->
<!--          :multiple="true"-->
<!--      />-->
<!--    </div>-->

    <div class="line" v-if="changes">
      <div class="button_wrap">
        <button
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="update_profile"
        >
          save
        </button>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: "EditRolesForm",
  props: ['user'],
  data () {
    return {
      disabled_btn: false,
      user_group: '',
      user_roles: []
    }
  },
  created() {
    this.user_group = this.user.group
  },
  computed:{
    group_list(){
      let list = []
      if (this.user.client_id !== null){
        for (let group of this.$store.getters.getDeviceGroupsTree) {
          if (group.client_id === this.user.client_id) {
            list.push(group)
          }
        }
      }else{
        list = this.$store.getters.getDeviceGroupsTree
      }
      return list
    },
    changes(){
      return JSON.stringify(this.user_group) !== JSON.stringify(this.user.group)
    },
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    update_profile(){
      let params = {
        "user_id": this.user.id,
        "device_groups": this.user_group,
        "simcard_groups": []
      }
      this.$http.v1.updateGroups(params, (response) => {
        if (response.data.code === 409) {
          this.global_notify('danger', this.translate('user.saved_error'))
          this.disabled_btn = false
        }else{
          this.global_notify('info', this.translate('user.saved'))
          this.user_group = response.data.device_groups
          this.$emit('update_groups', response.data.device_groups)
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
  .line{
    text-align: left;
  }

</style>
